import { ComponentType } from 'ngx-golden-layout';
import { MapComponent } from '../map/map.component';
import { TractorsGridComponent } from '../tractors-grid/tractors-grid.component';
import { MapTractorsComponent } from '../map-tractors/map-tractors.component';
import { MapFieldsComponent } from '../map-fields/map-fields.component';
import { FieldsGridComponent } from '../fields-grid/fields-grid.component';
import { TrackersGridComponent } from '../trackers-grid/trackers-grid.component';
import { TrackerAssignmentGridComponent } from '../trackers-grid/tracker-assignment-grid/tracker-assignment-grid.component';
import { TrailerOperationTypesGridComponent } from '../trailer-operation-types-grid/trailer-operation-types-grid.component';
import { TrailersGridComponent } from '../trailers-grid/trailers-grid.component';
import { ProfileEditFormComponent } from 'shared';
import { TractorsHistoryComponent } from '../tractors/tractors-history/tractors-history.component';
import { TrailerInterventionsGridComponent } from '../trailer-interventions-grid/trailer-interventions-grid.component';
import { ReportsGridComponent } from '../reports/reports-grid/reports-grid.component';
import { FieldsGeneralReportComponent } from '../fields-report/fields-general-report/fields-general-report.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { TagsGridComponent } from '../tags/tags-grid/tags-grid.component';
import { MapPoiComponent } from '../map-poi/map-poi.component';
import { TransportInterventionsGridComponent } from '../transport-interventions/transport-interventions-grid/transport-interventions-grid.component';
import { UsersGridComponent } from '../users/users-grid/users-grid.component';
import { DriversGridComponent } from '../drivers/drivers-grid/drivers-grid.component';
import { FieldEditorComponent } from '../fields/field-editor/field-editor.component';
import { CropsGridComponent } from '../crops/crops-grid/crops-grid.component';
import { FlowMeterReportPageComponent } from '../fuel/flow-meter/flow-meter-report-page/flow-meter-report-page.component';
import { TransportInterventionsPageComponent } from '../transport-interventions/transport-interventions-page/transport-interventions-page.component';
import { TanksGridComponent } from '../tanks/tanks-grid/tanks-grid.component';
import { FieldsInterventionsPageComponent } from '../fields-interventions/fields-interventions-page/fields-interventions-page.component';
import { TicketsGridComponent } from '../tickets-grid/tickets-grid.component';
import { FieldsCropsGridComponent } from '../fields-crops-grid/fields-crops-grid.component';
import { ReconstructedInterventionsGridComponent } from '../reconstructed-interventions-grid/reconstructed-interventions-grid.component';
import { ParametersComponent } from '../parameters/parameters.component';

// Define all component types known at compile time to the golden-layout binding.
// It's possible to modify these at runtime using the `ComponentRegistryService`
export const layoutComponentTypes: ComponentType[] = [{
  name: 'profile-edit',
  type: ProfileEditFormComponent,
}, {
  name: 'dashboard',
  type: DashboardComponent,
}, {
  name: 'map',
  type: MapComponent,
}, {
  name: 'map-tractors',
  type: MapTractorsComponent,
}, {
  name: 'map-fields',
  type: MapFieldsComponent,
}, {
  name: 'map-poi',
  type: MapPoiComponent,
}, {
  name: 'tractors-grid',
  type: TractorsGridComponent,
}, {
  name: 'tractors-history',
  type: TractorsHistoryComponent,
}, {
  name: 'flow-meter-report-page',
  type: FlowMeterReportPageComponent,
}, {
  name: 'fields-grid',
  type: FieldsGridComponent,
}, {
  name: 'fields-crops-grid',
  type: FieldsCropsGridComponent,
}, {
  name: 'fields-general-report',
  type: FieldsGeneralReportComponent,
}, {
  name: 'trackers-grid',
  type: TrackersGridComponent,
}, {
  name: 'trackers-assignment-grid',
  type: TrackerAssignmentGridComponent,
}, {
  name: 'trailer-operation-types-grid',
  type: TrailerOperationTypesGridComponent,
}, {
  name: 'trailers-grid',
  type: TrailersGridComponent,
}, {
  name: 'trailer-interventions-grid',
  type: FieldsInterventionsPageComponent,
}, {
  name: 'transport-interventions-page',
  type: TransportInterventionsPageComponent,
}, {
  name: 'reports-grid',
  type: ReportsGridComponent,
}, {
  name: 'tags-grid',
  type: TagsGridComponent,
}, {
  name: 'users-grid',
  type: UsersGridComponent,
}, {
  name: 'drivers-grid',
  type: DriversGridComponent,
}, {
  name: 'field-editor',
  type: FieldEditorComponent,
}, {
  name: 'crops-grid',
  type: CropsGridComponent,
}, {
  name: 'tanks-grid',
  type: TanksGridComponent,
}, {
  name: 'tickets-grid',
  type: TicketsGridComponent,
}, {
  name: 'reconstructed-interventions-grid',
  type: ReconstructedInterventionsGridComponent,
}, {
  name: 'parameters',
  type: ParametersComponent,
}];
